import { SubmittedConsultantInfo } from '@core/store/start-now-app/start-now-app-state-models';

export const DefaultFailedSubmittedConsultantInfo: SubmittedConsultantInfo = {
  errorTypes: [],
  isSuccess: false,
  consultantBeeNumber: null,
  recruiterInfo: null,
};
